class PersistentCache {
  store = new Map();
  path = 'defaultPersistentCache';
  maxSize = 50;

  constructor(path, maxSize) {
    this.path = path;
    this.maxSize = maxSize || this.maxSize;
    const data = localStorage.getItem(path);
    if (data) {
      this.store = new Map(JSON.parse(data));
    }
  }

  persist() {
    localStorage.setItem(this.path, JSON.stringify([...this.store]));
  }

  set(key, value) {
    const entries = [...this.store];
    if (entries.length >= this.maxSize) {
      this.store.delete(entries[0][0]);
    }
    this.store.set(key, value);
    this.persist();
  }

  get(key) {
    // TODO: consider being defensive here and returning a copy of the cached object
    return this.store.get(key);
  }

  eject(key) {
    this.store.delete(key);
  }
}

export default PersistentCache;
